import http from '@/http'

const PATH = '/customers'

function getPath (customerId) {
    return `${PATH}/${customerId}/activities`
}

export default {
    /**
     * @param {{customerId: number, params: {}}} data
     * @returns {Promise<void>}
     */
    async listActivities ({customerId, params}) {
        try {
            const response = await http.get(getPath(customerId), {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number, activityId: number}} data
     * @returns {Promise<void>}
     */
    async showActivity ({customerId, activityId}) {
        try {
            const response = await http.get(
                `${getPath(customerId)}/${activityId}`
            )
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
